import { cssAnchorProps } from "@circle-react/helpers/cssAnchorHelpers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";
import { useIsMobileShellEnabled } from "@/react/components/Mobile/hooks/useIsMobileShellEnabled";

export interface CommunityLogoProps {
  className?: string;
  name: string;
  src: string;
}

export const CommunityLogo = ({ name, src, className }: CommunityLogoProps) => {
  const isMobileShellEnabled = useIsMobileShellEnabled();
  return (
    <img
      loading="eager"
      id="community-logo"
      alt={t("community_logo_alt", { community_name: name })}
      className={classNames(
        "max-h-9 max-w-[14.375rem]",
        {
          "w-auto object-contain": isMobileShellEnabled,
        },
        className,
      )}
      src={src}
      {...cssAnchorProps({ anchor: "app-topbar-logo-image" })}
    />
  );
};
